<template>
    <div>
       <HeaderTeam header="ลางาน" :img_header="header_image" link_back="team"/>
       <LeaveWorkList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/contact-form.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import LeaveWorkList from '@/components/menuadmin/team/teamleavework/LeaveWorkList.vue'
export default {
    name:'leaveWork',
    components:{
        HeaderTeam,
        LeaveWorkList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>